import { useMemo } from 'react';

import { useSections } from '../../../../../store/app/appStore';

import {SECTIONS_WITH_JACKPOTS} from '../../../constants';

const ALLOWED_SECTION_WITH_JACKPOTS = [
  SECTIONS_WITH_JACKPOTS['BELL_LINK'],
  SECTIONS_WITH_JACKPOTS['GODS_AND_KINGS'],
  SECTIONS_WITH_JACKPOTS['BELL_LINK_BOOST']
];

const VIP_ALLOWED_SECTION_WITH_JACKPOTS = [
  SECTIONS_WITH_JACKPOTS['VIP_BELL_LINK'],
  SECTIONS_WITH_JACKPOTS['VIP_GODS_AND_KINGS'],
  SECTIONS_WITH_JACKPOTS['VIP_BELL_LINK_BOOST']
];

export default function useGetLinkedJackpots(sectionName: string) {
  const { sections } = useSections();
  const allowedJackpotSections = sectionName.includes('VIP') 
    ? VIP_ALLOWED_SECTION_WITH_JACKPOTS 
    : ALLOWED_SECTION_WITH_JACKPOTS;

  const hasLinkedJackpots = useMemo(() => (
    allowedJackpotSections.includes(sectionName) && sections.some(({name}) => name === sectionName)
  ), [allowedJackpotSections, sectionName, sections]);

  if (!hasLinkedJackpots) {
    return null;
  }

return useMemo(() => (
  sections.reduce((acc: string[], {name}) => (
    allowedJackpotSections.includes(name) 
      ? [...acc, name]
      : acc
  ), [])
), [sections, allowedJackpotSections]);
}